const menuwords ={
    'ht0':{'es':'Inicio','en':'Home'},
    'ht1':{'es':'Trabajos','en':'Projects'},
    'ht2':{'es':'Sobre mi','en':'About me'},
    'ht3':{'es':'Contacto','en':'Contact'},
    'ht4':{'es':'Descargar CV','en':'Download Resume'}
}

export default menuwords;